export default __webpack_public_path__ + "static/media/women.9c65adf4.jpg";